





































import Vue from 'vue'
import request from '@/utils/request'
import moment from 'moment'
import sha1 from 'sha1'
import { WECHAT_APPID, WECAHT_NAME, IMG_URL } from '@/utils/constants'
import { wxShare } from '@/utils/wxApi'
export default Vue.extend({
  created() {
    //@ts-ignore
    this.category_id = this.$route.query.id
    if (this.category_id === '4') {
      this.title = '气象科普'
      document.title = this.title
      this.default_img = '/static/image/qixiangkepu.png'
      this.bgImg = '/static/image/kepubg.png'
    }
    else if (this.category_id === '5') {
      this.title = '法律法规'
      document.title = this.title
      this.default_img = '/static/image/falvfagui.png'
      this.bgImg = '/static/image/faguibg.png'
    }
    else if (this.category_id === '6') {
      this.title = '重要天气'
      document.title = this.title
      this.default_img = '/static/image/zhongyaotianqi.png'
      this.bgImg = '/static/image/zhongyaoBg.png'
    }
    else if (this.category_id === '7') {
      this.title = '专题报告'
      document.title = this.title
      this.default_img = '/static/image/zhuantibaogao.png'
      this.bgImg = '/static/image/zhuantiBg.png'
    }
    else if (this.category_id === '8') {
      this.title = '冬枣专题'
      document.title = this.title
      this.default_img = '/static/image/dongzaozhuanti.png'
      this.bgImg = '/static/image/dongzaozhuantiBg.png'
    }
    this.initWeixin()
    this.getData()

  },
  data() {
    return {
      category_id: '' as string,
      articles: [] as any[],
      title: '',
      default_img: '' as string,
      bgImg: '' as string
    }
  },
  methods: {
    getData() {
      const params = {
        categoryId: this.category_id
      }
      request.get('/api/column/article/show', params).then((data) => {
        const alldata = JSON.parse(JSON.stringify(data))
        this.articles = data
      })
    },
    toInfo(id: string) {
      this.$router.push('/article_details?id=' + id)
    },
    dateStr(dateStr: string) {
      let pattern = /(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/;
      //将时间格式化成 yyyy-MM-dd HH:mm:ss
      let formatDateStr = dateStr.toString().replace(pattern, '$1-$2-$3 $4:$5:$6');
      return formatDateStr;
    },
    async initWeixin() {
      const url = window.location.href
      const timestamp = moment().valueOf()
      const nonceStr = 'tongzhouwechat'
      const jsapiTicket = await request.get('/api/account/office_account/jsapi_ticket')
      console.log('jsapiTicket', jsapiTicket)
      const params = `jsapi_ticket=${jsapiTicket}&noncestr=${nonceStr}&timestamp=${timestamp}&url=${url}`
      console.log('params', params)
      const signature = sha1(params)
      const obj = {
        appId: WECHAT_APPID,
        nonceStr: nonceStr,
        signature: signature,
        timestamp: timestamp,
      }

      let shareData = {
        title: WECAHT_NAME,
        desc: document.title,
        imgUrl: IMG_URL,
        link: url,
      };
      wxShare(obj, shareData);
    },


  },

  filters: {
    dtFormat(timestamp: number) {
      const time = moment(timestamp)
      return time.format('YYYY-MM-DD HH:mm:ss')
    },
  },
})
